import iClinicApi from 'services/iclinic/iClinicApi';

export const verifyEditPaymentPossibility = () =>
  iClinicApi.get('/subscriptions/subscription/user-can-change-day-billing');

export const changeBillingDay = ({ billingDay }: { billingDay: number }) =>
  iClinicApi.post('/subscriptions/subscription/change-day-billing/', {
    day_billing: billingDay,
  });
